import { useState } from "react";
import { motion } from "framer-motion";
import { BellRing, X } from "lucide-react";
import { toast } from "sonner";
import { canAskPush, dismissPush, enablePush } from "../../lib/live";

export const PushBanner = ({ chat, cfg }) => {
  const [show, setShow] = useState(canAskPush);
  const [busy, setBusy] = useState(false);
  if (!show || !chat || !cfg?.vapid_public) return null;

  const accept = async () => {
    setBusy(true);
    try {
      const ok = await enablePush(chat, cfg);
      if (ok) toast.success("Pronto! Você vai receber um aviso quando responderem.");
      else dismissPush();
    } catch {
      toast.error("Não foi possível ativar os avisos neste aparelho.");
    } finally {
      setBusy(false);
      setShow(false);
    }
  };

  const close = () => { dismissPush(); setShow(false); };

  return (
    <motion.div data-testid="push-banner" className="lz-push" initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}>
      <span className="lz-push-icon"><BellRing size={18} /></span>
      <p className="flex-1 text-[13.5px] leading-snug">Receber aviso quando responderem?</p>
      <button data-testid="push-accept" onClick={accept} disabled={busy} className="lz-push-yes">{busy ? "..." : "Sim"}</button>
      <button data-testid="push-dismiss" onClick={close} className="lz-push-no" aria-label="Agora não"><X size={16} /></button>
    </motion.div>
  );
};
